var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarFeedbackBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.079,
    height: 18,
    viewBox: "0 0 18.079 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.059,
    y1: 0.36,
    x2: 1.242,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bc7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03facf"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_2_",
    "data-name": "star(2)",
    d: "M36.757,46l-.689-2.432L35.379,46ZM35.748,28.206a.351.351,0,0,1,.64,0l2.468,5.443,5.939.665a.351.351,0,0,1,.2.608l-4.414,4.029,1.2,5.854a.351.351,0,0,1-.517.376l-5.2-2.953-5.2,2.953a.351.351,0,0,1-.518-.376l1.2-5.854-4.414-4.029a.351.351,0,0,1,.2-.608l5.939-.665Zm-7.56,12.575,2.1-1.409-2.526.1Zm16.2-1.34-2.527-.09,2.1,1.4Zm-13.919-8.4,2,1.55-.888-2.367Zm10.082-.828-.882,2.369,1.994-1.554Z",
    transform: "translate(-27.029 -28)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFeedbackBtn);
export default __webpack_public_path__ + "static/media/starFeedbackBtn.d43fd8b443857b8e2197b34fbb7e3bd0.svg";
export { ForwardRef as ReactComponent };